/**
 * Canonical name → slug normalization, shared by the client link resolver and (conceptually) the
 * server's `entityIdFor`/`slug`. `[[Vickers]]`, `[[  vickers ]]` and `#vickers` all collapse to the
 * same key, so a wikilink target can be matched against a page's title/aliases regardless of casing
 * or punctuation. Keep this in lockstep with `server-api/graph/model.ts#slug` — the two must agree
 * for a locally-resolved link to point at the same page the server's entity index would.
 */
export function slugName(name: string): string {
  return name
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
}
